import React,{FC} from "react";

export interface EventMarkerAcronymProps{
    colorCode:string;
}

export const EventMarkerAcronym: FC<EventMarkerAcronymProps> = (props) => {
    const {colorCode}= props;

    return(
        <span style={{backgroundColor: '#' + colorCode, marginRight: "0px"}} className="acronymBlock" ></span>
    );

}
export default EventMarkerAcronym;